module.exports = "pegasus_template/assets/pexels-photo.png";